<mat-accordion>
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-title-small">
        Application Info
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul>
      <li>App version: {{ appVersion }}</li>
    </ul>
  </mat-expansion-panel>
</mat-accordion>
